import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from '../../../app/store'

export const CompletionView: React.FC = () => {
  const navigate = useNavigate()
  const { outro } = useSelector((state: RootState) => state.endJourney)
  const contentLines = outro.content.split('\\n')

  const handleClose = () => {
    // Navigate back to the previous page instead of trying to close the window
    navigate(-1)
  }

  const handleGoHome = () => {
    navigate('/')
  }

  return (
    <div className="bg-white rounded-lg shadow-sm">
      <div className="max-w-2xl mx-auto px-8 py-16">
        <div className="text-center space-y-6">
          <h1 className="text-[32px] font-semibold text-gray-900">
            {outro.title}
          </h1>

          <div className="text-gray-600 text-base space-y-2">
            {contentLines.map((line: string, index: number) => (
              <p key={index}>{line}</p>
            ))}
          </div>

          {/* Image placeholder with gray background */}
          {/* <div className="mt-8 aspect-video max-w-xl mx-auto rounded-lg bg-gray-200 flex items-center justify-center">
            <span className="text-gray-400">Image placeholder</span>
          </div> */}

          {/* CTAs */}
          <div className="mt-8 flex justify-center gap-4">
            <button
              onClick={handleClose}
              className="px-6 py-2 bg-white text-gray-700 rounded-full font-medium border border-gray-200 hover:bg-gray-50"
            >
              Close Tab
            </button>
            <button
              onClick={handleGoHome}
              className="px-6 py-2 bg-primary text-white rounded-full font-medium hover:bg-primary-600"
            >
              Go to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
